import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { WalletIcon } from "@components/icons/WalletIcon";
import WalletTag from "@components/shared/WalletTag";
import { useRootAppStore } from "@hooks";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { shouldShowBetSlipStatus } from "@utils/offer/shouldShowBetSlipStatus";
import { shouldUseSlipStatusInstead } from "@utils/offer/shouldUseSlipStatusInstead";
import { observer } from "mobx-react";

import BetCardBodyTitle from "./BetCardBodyTitle";
import FreebetTag from "@components/shared/FreebetTag";

export default observer(function BetCardLinkHeader() {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);

	const store = useRootAppStore();

	const betAccountTypeAbrv =
		store.userAuthStore.userAccounts?.find(
			(wallet) => wallet.accountTypeId === bet?.bettingAccountTypeId
		)?.abrv || null;

	let betStatus = bet.betStatus;
	let tagClasses = `bet--mini__tag tag tag--tny tag--bet--${betStatus?.abrv}`;

	if (shouldUseSlipStatusInstead(bet)) {
		betStatus = bet.betSlipStatus;
		tagClasses = `bet__tag tag tag--tny tag--slip--${betStatus.abrv}`;
	}

	return (
		<div className="bet--mini__header">
			<div className="bet__title bet--mini__title">
				{bet.hasBetBuilder && (
					<i className="u-icon u-icon--bb--active u-icon--sml bet--mini__icon--bb" />
				)}

				<BetCardBodyTitle />

				<WalletTag
					isWalletManuallyDisabled={
						bet.isWalletManuallyDisabled || false
					}
				/>

				<WalletIcon
					bettingAccountTypeAbrv={betAccountTypeAbrv || ""}
					iconSize="u-icon--sml"
					classList="bet--mini__icon--wallet"
					isWalletManuallyDisabled={
						bet.isWalletManuallyDisabled || false
					}
				/>
			</div>

			<div className="bet--mini__tags">
				<span className={tagClasses}>
					{betStatus?.name}{" "}
					{bet.isLive ? (
						<> - {t("ITEM.LIVE_SCORE").toUpperCase()}</>
					) : null}
					{bet.isBonus && <> ({t<string>("COMMON.BONUS")})</>}
				</span>
                {shouldShowBetSlipStatus(bet) && (
					<span
						className={
							"bet__tag tag tag--tny tag--slip--" +
							bet.betSlipStatus.abrv
						}
					>
						{bet.betSlipStatus.name}
					</span>
				)}
                <FreebetTag isFreebet={bet.isFreebet} />
                
			</div>
		</div>
	);
});
